/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import loadable from '@loadable/component';

import Advertisement from '../components/Advertisement';
import Announcements from '../components/Announcements';
import ArticleInfo from '../components/ArticleInfo';
import ContributorDetail from '../components/ContributorDetail';
import ContributorInfo from '../components/ContributorInfo';
import EmbedAdobeMarketoForm from '../components/EmbedAdobeMarketoForm';
import FeatureSection from '../components/FeatureSection';
import FeatureSectionWithAd from '../components/FeatureSectionWithAd';
import MagazineBanner from '../components/MagazineBanner';
import MagazineIssuesCarousel from '../components/MagazineIssuesCarousel';
import MagazinePageBanner from '../components/MagazinePageBanner';
import MetadataInTheBlack from '../components/MetadataInTheBlack';
import MMFCareerProfileForm from '../components/MMFCareerProfileForm';
import MMFContactDetailsForm from '../components/MMFContactDetailsForm';
import PageBanner from '../components/PageBanner';
import PageFooter from '../components/PageFooter';
import PageHeader from '../components/PageHeader';
import PlaceholderFullWidth from '../components/PlaceholderFullWidth';
import PlaceholderSingleColumn from '../components/PlaceholderSingleColumn';
import ShowcaseHero from '../components/ShowcaseHero';
import SponsorLogo from '../components/SponsorLogo';

const components = new Map();

  // dynamic component Accordion
  components.set('Accordion', loadable(() => import(/* webpackChunkName: "Accordion" */'../components/Accordion'), { ssr: true}))

  // standard component Advertisement
  components.set('Advertisement', Advertisement);

  // standard component Announcements
  components.set('Announcements', Announcements);

  // standard component ArticleInfo
  components.set('ArticleInfo', ArticleInfo);

  // dynamic component BackToTop
  components.set('BackToTop', loadable(() => import(/* webpackChunkName: "BackToTop" */'../components/BackToTop'), { ssr: true}))

  // dynamic component CallToAction
  components.set('CallToAction', loadable(() => import(/* webpackChunkName: "CallToAction" */'../components/CallToAction'), { ssr: true}))

  // dynamic component CardListInTheBlack
  components.set('CardListInTheBlack', loadable(() => import(/* webpackChunkName: "CardListInTheBlack" */'../components/CardListInTheBlack'), { ssr: true}))

  // dynamic component ContentRelated
  components.set('ContentRelated', loadable(() => import(/* webpackChunkName: "ContentRelated" */'../components/ContentRelated'), { ssr: true}))

  // dynamic component ContentRichText
  components.set('ContentRichText', loadable(() => import(/* webpackChunkName: "ContentRichText" */'../components/ContentRichText'), { ssr: true}))

  // dynamic component ContentSummary
  components.set('ContentSummary', loadable(() => import(/* webpackChunkName: "ContentSummary" */'../components/ContentSummary'), { ssr: true}))

  // standard component ContributorDetail
  components.set('ContributorDetail', ContributorDetail);

  // standard component ContributorInfo
  components.set('ContributorInfo', ContributorInfo);

  // dynamic component CountryPreferenceSelector
  components.set('CountryPreferenceSelector', loadable(() => import(/* webpackChunkName: "CountryPreferenceSelector" */'../components/CountryPreferenceSelector'), { ssr: true}))

  // dynamic component CoveoContentCards
  components.set('CoveoContentCards', loadable(() => import(/* webpackChunkName: "CoveoContentCards" */'../components/CoveoContentCards'), { ssr: false}))

  // standard component EmbedAdobeMarketoForm
  components.set('EmbedAdobeMarketoForm', EmbedAdobeMarketoForm);

  // dynamic component EmbeddedCoveoSearch
  components.set('EmbeddedCoveoSearch', loadable(() => import(/* webpackChunkName: "EmbeddedCoveoSearch" */'../components/EmbeddedCoveoSearch'), { ssr: true}))

  // standard component FeatureSection
  components.set('FeatureSection', FeatureSection);

  // standard component FeatureSectionWithAd
  components.set('FeatureSectionWithAd', FeatureSectionWithAd);

  // dynamic component Form
  components.set('Form', loadable(() => import(/* webpackChunkName: "Form" */'../components/Form'), { ssr: true}))

  // dynamic component HiddenRendering
  components.set('HiddenRendering', loadable(() => import(/* webpackChunkName: "HiddenRendering" */'../components/HiddenRendering'), { ssr: true}))

  // dynamic component Icon
  components.set('Icon', loadable(() => import(/* webpackChunkName: "Icon" */'../components/Icon'), { ssr: true}))

  // dynamic component IFrame
  components.set('IFrame', loadable(() => import(/* webpackChunkName: "IFrame" */'../components/IFrame'), { ssr: true}))

  // dynamic component ImageWithTitleAndText
  components.set('ImageWithTitleAndText', loadable(() => import(/* webpackChunkName: "ImageWithTitleAndText" */'../components/ImageWithTitleAndText'), { ssr: true}))

  // dynamic component InformationSession
  components.set('InformationSession', loadable(() => import(/* webpackChunkName: "InformationSession" */'../components/InformationSession'), { ssr: true}))

  // dynamic component InPageBanner
  components.set('InPageBanner', loadable(() => import(/* webpackChunkName: "InPageBanner" */'../components/InPageBanner'), { ssr: true}))

  // dynamic component InternalPageBanner
  components.set('InternalPageBanner', loadable(() => import(/* webpackChunkName: "InternalPageBanner" */'../components/InternalPageBanner'), { ssr: true}))

  // dynamic component LateralNavigation
  components.set('LateralNavigation', loadable(() => import(/* webpackChunkName: "LateralNavigation" */'../components/LateralNavigation'), { ssr: true}))

  // dynamic component LinkList
  components.set('LinkList', loadable(() => import(/* webpackChunkName: "LinkList" */'../components/LinkList'), { ssr: true}))

  // dynamic component ListArticle
  components.set('ListArticle', loadable(() => import(/* webpackChunkName: "ListArticle" */'../components/ListArticle'), { ssr: true}))

  // standard component MagazineBanner
  components.set('MagazineBanner', MagazineBanner);

  // standard component MagazineIssuesCarousel
  components.set('MagazineIssuesCarousel', MagazineIssuesCarousel);

  // standard component MagazinePageBanner
  components.set('MagazinePageBanner', MagazinePageBanner);

  // dynamic component MainMenu
  components.set('MainMenu', loadable(() => import(/* webpackChunkName: "MainMenu" */'../components/MainMenu'), { ssr: true}))

  // dynamic component MainSearch
  components.set('MainSearch', loadable(() => import(/* webpackChunkName: "MainSearch" */'../components/MainSearch'), { ssr: true}))

  // dynamic component MediaEmbed
  components.set('MediaEmbed', loadable(() => import(/* webpackChunkName: "MediaEmbed" */'../components/MediaEmbed'), { ssr: true}))

  // dynamic component MenuButton
  components.set('MenuButton', loadable(() => import(/* webpackChunkName: "MenuButton" */'../components/MenuButton'), { ssr: true}))

  // standard component MetadataInTheBlack
  components.set('MetadataInTheBlack', MetadataInTheBlack);

  // standard component MMFCareerProfileForm
  components.set('MMFCareerProfileForm', MMFCareerProfileForm);

  // standard component MMFContactDetailsForm
  components.set('MMFContactDetailsForm', MMFContactDetailsForm);

  // dynamic component MobileBanner
  components.set('MobileBanner', loadable(() => import(/* webpackChunkName: "MobileBanner" */'../components/MobileBanner'), { ssr: true}))

  // dynamic component Modal
  components.set('Modal', loadable(() => import(/* webpackChunkName: "Modal" */'../components/Modal'), { ssr: true}))

  // dynamic component MultiEventBanner
  components.set('MultiEventBanner', loadable(() => import(/* webpackChunkName: "MultiEventBanner" */'../components/MultiEventBanner'), { ssr: true}))

  // dynamic component MultiMediaEmbed
  components.set('MultiMediaEmbed', loadable(() => import(/* webpackChunkName: "MultiMediaEmbed" */'../components/MultiMediaEmbed'), { ssr: true}))

  // dynamic component NavItem
  components.set('NavItem', loadable(() => import(/* webpackChunkName: "NavItem" */'../components/NavItem'), { ssr: true}))

  // dynamic component NewSocialShare
  components.set('NewSocialShare', loadable(() => import(/* webpackChunkName: "NewSocialShare" */'../components/NewSocialShare'), { ssr: true}))

  // dynamic component PaddingSpacer
  components.set('PaddingSpacer', loadable(() => import(/* webpackChunkName: "PaddingSpacer" */'../components/PaddingSpacer'), { ssr: true}))

  // standard component PageBanner
  components.set('PageBanner', PageBanner);

  // dynamic component PageBannerWithNews
  components.set('PageBannerWithNews', loadable(() => import(/* webpackChunkName: "PageBannerWithNews" */'../components/PageBannerWithNews'), { ssr: true}))

  // standard component PageFooter
  components.set('PageFooter', PageFooter);

  // standard component PageHeader
  components.set('PageHeader', PageHeader);

  // standard component PlaceholderFullWidth
  components.set('PlaceholderFullWidth', PlaceholderFullWidth);

  // standard component PlaceholderSingleColumn
  components.set('PlaceholderSingleColumn', PlaceholderSingleColumn);

  // dynamic component SearchBar
  components.set('SearchBar', loadable(() => import(/* webpackChunkName: "SearchBar" */'../components/SearchBar'), { ssr: true}))

  // dynamic component SearchMenu
  components.set('SearchMenu', loadable(() => import(/* webpackChunkName: "SearchMenu" */'../components/SearchMenu'), { ssr: true}))

  // dynamic component SearchMenuButton
  components.set('SearchMenuButton', loadable(() => import(/* webpackChunkName: "SearchMenuButton" */'../components/SearchMenuButton'), { ssr: true}))

  // dynamic component SearchResultsInTheBlack
  components.set('SearchResultsInTheBlack', loadable(() => import(/* webpackChunkName: "SearchResultsInTheBlack" */'../components/SearchResultsInTheBlack'), { ssr: false}))

  // standard component ShowcaseHero
  components.set('ShowcaseHero', ShowcaseHero);

  // dynamic component SingleImage
  components.set('SingleImage', loadable(() => import(/* webpackChunkName: "SingleImage" */'../components/SingleImage'), { ssr: true}))

  // standard component SponsorLogo
  components.set('SponsorLogo', SponsorLogo);

  // dynamic component StaticTextAndImage
  components.set('StaticTextAndImage', loadable(() => import(/* webpackChunkName: "StaticTextAndImage" */'../components/StaticTextAndImage'), { ssr: true}))

  // dynamic component Tabs
  components.set('Tabs', loadable(() => import(/* webpackChunkName: "Tabs" */'../components/Tabs'), { ssr: true}))

  // dynamic component TagList
  components.set('TagList', loadable(() => import(/* webpackChunkName: "TagList" */'../components/TagList'), { ssr: true}))

export default function componentFactory(componentName) {
  return components.get(componentName);
};
